import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import { ReactComponent as Bold } from "../../../../assets/previewPage/Bold.svg";
import HomeIcon from "../../../../assets/map/home.png";
import { ReactComponent as CallIcon } from "../../../../assets/map/call.svg";
import { ReactComponent as LocationIcon } from "../../../../assets/map/location.svg";

// Import marker icon image
import MarkerIcon from "../../../../assets/MainPage/addBlock/marker.svg";
import PrimaryMarkerIcon from "../../../../assets/MainPage/addBlock/primary.svg";
import useLocales from "../../../../hooks/useLocales";

const LocationCard = ({ item, styles }) => {
  const { translate } = useLocales();

  const [coloumValue, setColoumValue] = useState(null);
  const [mapCenter, setMapCenter] = useState();
  const [mapZoom, setMapZoom] = useState();

  useEffect(() => {
    if (item?.coloum_value) {
      try {
        const parsedColoumValue = JSON.parse(item.coloum_value);
        setColoumValue(parsedColoumValue);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, [item]);

  useEffect(() => {
    if (coloumValue) {
      // Find the primary location, if any
      const primaryLocation = coloumValue?.find(
        (location) => location.isPrimary
      );

      // If a primary location is found, set the map center and zoom level accordingly
      if (primaryLocation) {
        setMapCenter([primaryLocation.lat, primaryLocation.lon]);
        setMapZoom(5);
      } else {
        // If no primary location is found, use default map center and zoom level
        setMapCenter([20, 0]); // Default center coordinates
        setMapZoom(2); // Default zoom level
      }
    }
  }, [coloumValue]);

  const handleMarkerClick = (map, lat, lon) => {
    map.flyTo([lat, lon], 15, {
      duration: 1,
    });
  };

  const truncateTitle = (title) => {
    if (title.length > 7) {
      return title.slice(0, 7) + "...";
    }
    return title;
  };

  return (
    <div className="flex flex-col items-center justify-center w-full">
      <div
        className="w-full"
        style={{
          padding: "30px 24px 30px 24px",
          gap: "16px",
          borderRadius: "16px",
          opacity: "0px",
          boxShadow: "0px 22px 75px 0px rgba(0, 0, 0, 0.05)",
          background: "rgba(255, 255, 255, 1)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
          }}
        >
          <h1 className="text-body_copy2_black"> {translate("my_location")}</h1>
          <Bold />
        </div>
        <div
          style={{
            width: "100%",
            height: "300px",
            borderRadius: "6px",
            border: "1px solid rgba(221, 221, 221, 1)",
            marginTop: "20px",
          }}
        >
          {mapCenter && mapZoom && (
            <MapContainer
              center={mapCenter}
              zoom={mapZoom}
              style={{ width: "100%", height: "100%", zIndex: "1" }}
              zoomControl={false}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution=""
              />
              {coloumValue?.map((location, idx) => (
                <Marker
                  key={idx}
                  position={[location.lat, location.lon]}
                  icon={L.icon({
                    // iconUrl: MarkerIcon,
                    iconUrl: location.isPrimary
                      ? PrimaryMarkerIcon
                      : MarkerIcon,
                    // iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                  })}
                  eventHandlers={{
                    click: (e) => {
                      handleMarkerClick(
                        e.target._map,
                        location.lat,
                        location.lon
                      );
                    },
                  }}
                >
                  <Popup>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "auto",
                        height: "auto",
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <img
                          src={HomeIcon}
                          alt="Home Icon"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "5px",
                          }}
                        />
                        <strong className="text-small1_bold">Home</strong>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          marginTop: "20px",
                        }}
                      >
                        <div style={{ display: "flex" }}>
                          <CallIcon
                            style={{ marginRight: "5px" }}
                            className="h-4 w-4 flex-shrink-0"
                          />
                          {location.phone && (
                            <div className="flex-grow">{location.phone}</div>
                          )}
                        </div>
                        <div style={{ display: "flex" }}>
                          <LocationIcon
                            style={{ marginRight: "5px" }}
                            className="h-4 w-4 flex-shrink-0"
                          />
                          <div className="flex-grow">
                            {truncateTitle(location.title)}
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          marginTop: "20px",
                        }}
                      >
                        <LocationIcon
                          style={{ marginRight: "5px" }}
                          className="h-4 w-4 flex-shrink-0"
                        />
                        <div className="flex-grow">
                          <a
                            href={location?.directionUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "inherit", textDecoration: "none" }}
                          >
                            {location.address}
                          </a>
                        </div>
                      </div>
                    </div>
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          )}
        </div>
      </div>
      <h3 className="text-sm mt-2 font-bold tracking-[-0.5px] text-main_color text-center">
        {coloumValue?.pageTitle}
      </h3>
    </div>
  );
};

export default LocationCard;
